import { render, staticRenderFns } from "./AddNewDocument.vue?vue&type=template&id=e3c47c96"
import script from "./AddNewDocument.vue?vue&type=script&lang=js"
export * from "./AddNewDocument.vue?vue&type=script&lang=js"
import style0 from "./AddNewDocument.vue?vue&type=style&index=0&id=e3c47c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports